const element = document.getElementById('SortBy');
const choices = new Choices(element, {
  searchEnabled: false,
  itemSelectText: '',
  allowHTML: true
});
function getColorOptionsCached() {
  const url = 'https://shopify-otech.matat.io/api/metaobjects/all?shop_domain=new-dreadlocks.myshopify.com&type=add_color_options';
  const CACHE_KEY = 'color_metaobjects_cache';
  const CACHE_TTL = 1000 * 60 * 10; // 10 minutes

  const now = Date.now();
  const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');

  // Use cached data if not expired
  if (cached.data && cached.timestamp && (now - cached.timestamp < CACHE_TTL)) {
    applyColorOptions(cached.data);
  } else {
    // Fetch new data and cache it
    fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then(data => {
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          data: data.data?.metaobjects || [],
          timestamp: Date.now()
        }));
        applyColorOptions(data.data?.metaobjects || []);
      })
      .catch(error => {
        console.error('Fetch error:', error);
        if (cached.data) {
          console.warn('Using stale cached data due to fetch error.');
          applyColorOptions(cached.data);
        }
      });
  }

  function applyColorOptions(metaobjects) {
  // Build lookup map for faster access
  const colorMap = new Map();

  for (const obj of metaobjects) {
    const displayName = obj?.displayName;
    if (typeof displayName === 'string' && displayName.trim() !== '') {
      const key = displayName.trim().toLowerCase();
      colorMap.set(key, obj.fields || {});
    }
  }

  const items = document.querySelectorAll('.variation-item');
  const updates = [];

  items.forEach((item) => {
    const colorName = item.getAttribute('data-color')?.trim().toLowerCase();
    const span = item.querySelector('.variation-item-span');
    if (!colorName || !span) return;

    const fields = colorMap.get(colorName);
    if (fields) {
      updates.push(() => {
        const colorImage = fields.color_image?.url;
        const colorCode = fields.color_code;

        if (colorImage) {
          span.style.backgroundImage = `url(${colorImage})`;
          span.style.backgroundSize = 'cover';
          span.style.backgroundPosition = 'center';
        } else if (colorCode) {
          span.style.backgroundColor = colorCode;
        }
      });
    }
  });

  requestAnimationFrame(() => {
    for (const update of updates) update();
  });
}

}

// NEW FUNCTION: Auto-select matching color variants based on active color filters
function autoSelectMatchingColorVariants() {
  // Only real facet inputs count as active filters. The previous selector read
  // `[name*="Color"]` / `[name*="color"]` page-wide, so it also picked up any card's
  // own color radio whose option is named in English, and then selected swatches on
  // unrelated cards whose `basic_color_for_grouping` happened to substring-match.
  const selectedColors = Array.from(document.querySelectorAll('input[name^="filter."]:checked'))
    .filter(i => {
      // This store's color facet is `filter.v.m.custom.basic_color_for_grouping`;
      // `צבע` also covers a facet built straight off the Hebrew color option.
      const name = i.name.toLowerCase();
      return name.includes('color') || name.includes('צבע');
    })
    .map(i => i.value.trim().toLowerCase())
    .filter(Boolean);

  if (selectedColors.length) {
    document.querySelectorAll('.variation-item[data-color-group]').forEach(label => {
      const colorGroup = label.getAttribute('data-color-group')?.trim().toLowerCase();
      if (!colorGroup || !selectedColors.some(c => colorGroup.includes(c) || c.includes(colorGroup))) return;

      const input = label.querySelector('input[type="radio"]');
      if (input && !input.disabled && !input.classList.contains('disabled')) {
        input.checked = true;
        ['click', 'input', 'change'].forEach(e => input.dispatchEvent(new Event(e, { bubbles: true })));
        input.closest('form')?.dispatchEvent(new Event('change', { bubbles: true }));
        MatatFiltersForm.ProductCardColorinfinite(input);
      }
    });
  }

  // Cards the filter didn't match still need a color selected, otherwise their
  // size buttons stay locked and inline quick-add does nothing. Runs second so an
  // active color filter keeps priority over the plain first-swatch default.
  window.selectDefaultCardColorSwatch?.();
}

class MatatFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.querySelector('button.button').addEventListener('click', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    facetForm.querySelector('.matat-filters__close').addEventListener('click', ()=> {
      facetForm.querySelector('.filter-opener').dispatchEvent(new Event('click'));
    });
    document.querySelector('#SortBy').addEventListener('change', function(e){

      const currentURL = window.location.href;
      const url = new URL(currentURL);
      const searchParams = url.searchParams;
      let new_search = '';
      searchParams.forEach((value, key) => {
          if (key === 'sort_by') {
              new_search += `&${key}=${document.querySelector('#SortBy').value}`;
          } else {
              new_search += `&${key}=${value}`;
          }
      });
      if(new_search == "&filter.v.availability=1"){
        new_search = `filter.v.availability=1&sort_by=${document.querySelector('#SortBy').value}`;
      }
      new_search = new_search.startsWith('&') ? new_search.substring(1) : new_search;
      if(new_search == ""){
        new_search=`&sort_by=${document.querySelector('#SortBy').value}`;
      }
      MatatFiltersForm.renderPage(new_search);
    });
    document.querySelector('#MatatFiltersForm').classList.add('loaded');
    document.querySelector('#ProductGridContainer').classList.add('loaded');
  }

  connectedCallback() {
    MatatFiltersForm.priceRangeSlider();
    // MatatFiltersForm.getCollectionsColor();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : MatatFiltersForm.searchParamsInitial;
      if (searchParams === MatatFiltersForm.searchParamsPrev) return;
      MatatFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    MatatFiltersForm.searchParamsPrev = searchParams;
    const sections = MatatFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      MatatFiltersForm.filterData.some(filterDataUrl) ?
        MatatFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        MatatFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) MatatFiltersForm.updateURLHash(searchParams);

    getColorOptionsCached();

    // Auto-select matching color variants after rendering
    setTimeout(() => {
      autoSelectMatchingColorVariants();
    }, 100);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        MatatFiltersForm.filterData = [...MatatFiltersForm.filterData, { html, url }];
        MatatFiltersForm.renderFilters(html, event);
        MatatFiltersForm.renderProductGridContainer(html);
        MatatFiltersForm.renderProductCount(html);
        if (window.initCollectionReadmore) window.initCollectionReadmore();
         setTimeout(() => {
          if (document.querySelector('.card__media.enable_image_slider .flickity_grid')) {
            const carousel = document.querySelectorAll('.card__media.enable_image_slider .flickity_grid');
            carousel.forEach((slide) => {
              new Flickity(slide, {
                cellAlign: "right",
                rightToLeft: true,
                contain: true,
                pageDots: false,
                fade: true,
                prevNextButtons: true
              });
            });
          }
           document.querySelectorAll('.card-variation-color input:checked').forEach(input => {
            MatatFiltersForm.ProductCardColorinfinite(input)
          });

          // Auto-select matching color variants after Flickity initialization
          autoSelectMatchingColorVariants();
        }, 600);
        
      }).then(()=> MatatFiltersForm.priceRangeSlider());
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = MatatFiltersForm.filterData.find(filterDataUrl).html;
    MatatFiltersForm.renderFilters(html, event);
    MatatFiltersForm.renderProductGridContainer(html);
    MatatFiltersForm.renderProductCount(html);
    if (window.initCollectionReadmore) window.initCollectionReadmore();

    // Auto-select matching color variants from cache
    setTimeout(() => {
      autoSelectMatchingColorVariants();
    }, 100);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    if(document.getElementById('ProductCount')){
      const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
      const container = document.getElementById('ProductCount');
      container.innerHTML = count;
      container.classList.remove('loading'); 
    }
  }

  static ProductCardColorinfinite(e){
      const selectedSkuinfinite = e.dataset.sku;
      const partsSkuinfnite = selectedSkuinfinite.split('--');
      const matchSkuinfinite = partsSkuinfnite.length >= 2 ? `${partsSkuinfnite[0]}--${partsSkuinfnite[1]}` : selectedSkuinfinite;
      
      const card_wrapperinfinite = e.closest('.card-wrapper'); // ✅ Finds the parent card
      if (!card_wrapperinfinite) {
        console.warn('No .card-wrapper found');
        return;
      }
  
      const card_innerinfinite = card_wrapperinfinite.querySelector('.card__inner'); // ✅ Scoped inside wrapper
      if (!card_innerinfinite) {
        console.warn('No .card__inner inside .card-wrapper');
        return;
      }
  
      const flickityGridinfinite = card_innerinfinite.querySelector('.card__media .flickity_grid');
      const flktyinfinite = flickityGridinfinite ? Flickity.data(flickityGridinfinite) : null;
  
      // No carousel on the card (settings.enable_image_slider off) - nothing to slide.
      if (!flktyinfinite) return;
      let matchingSlide = "";
      for (let e of card_innerinfinite.querySelectorAll(`.card__media .pro-media`)) {
        let altimage = e.getAttribute('data-image-alt') || '';
        let partsSkualtcard = altimage ? altimage.split(/--|-/) : [];
        let matchSkualtcard = partsSkualtcard.length >= 2 ? partsSkualtcard[0] + '--' + partsSkualtcard[1] : selectedSkuinfinite;
      
        if (matchSkualtcard === matchSkuinfinite) {
          matchingSlide = e;
          break;
        }
      }
      if (matchingSlide) {
        const targetIndexinfinite = parseInt(matchingSlide.dataset.index, 10);
        flktyinfinite.select(targetIndexinfinite);
      } else {
        console.warn('No matching slide found');
      }
    }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#MatatFiltersForm .js-filter, #MatatFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    MatatFiltersForm.renderActiveFacets(parsedHTML);
    MatatFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) MatatFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    MatatFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    // const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    // mobileElementSelectors.forEach((selector) => {
    //   if (!html.querySelector(selector)) return;
    //   document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    // });

    // document.getElementById('MatatFiltersForm').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static priceRangeSlider() {
    const myRangeInput = document.getElementById('matat-range-slider');
    if(myRangeInput){
      const rangeable = new Rangeable(myRangeInput, {
        type: "double",
        tooltips: false,
        step: 1,
        value: [myRangeInput.dataset.min, myRangeInput.dataset.max],
        vertical: false,
        handle: undefined,
        handles: undefined,
        onInit: function(value) {
          document.getElementById('Filter-Price-GTE').value = value[0];
          document.getElementById('Filter-Price-LTE').value = value[1];
          document.getElementById('selectedPriceMin').textContent = value[0];
          document.getElementById('selectedPriceMax').textContent = value[1];
        },
        onChange: function(value) {
          document.getElementById('Filter-Price-GTE').value = value[0];
          document.getElementById('Filter-Price-LTE').value = value[1];
          document.getElementById('selectedPriceMin').textContent = value[0];
          document.getElementById('selectedPriceMax').textContent = value[1];
        }
      });
    }
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    MatatFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('matat-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'MatatFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'MatatFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'MatatFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
    MatatFiltersForm.priceRangeSlider();
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    MatatFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    MatatFiltersForm.renderPage(url);
  }

  static getCollectionsColor() {
    fetch('https://matat-vibez.myshopify.com/api/2023-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/graphql',
        'X-Shopify-Storefront-Access-Token': "773817370033e23365e5dae095d4789e"
      },

      body: `{
        collection(handle: "נעליים") {
          products(first: 50) {
            filters {
              values {
                label
              }
              type
              label
            },
            edges {
              node {
                variants(first: 50) {
                  nodes {
                    colors: metafield(key: "colors", namespace: "custom") {
                      value
                    }
                  }
                }
              }
            }
          }
        }
      }`
    })
    .then(response => response.json())
    .then(response => {
      const colorFilter = response.data.collection.products.filters.filter( i => i.label == "Color" );
      const colorValues = colorFilter[0].values.map(x => x.label);
      // console.log(response.data.collection.products.edges);
    })
  }
}

MatatFiltersForm.filterData = [];
MatatFiltersForm.searchParamsInitial = window.location.search.slice(1);
MatatFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('matat-filters-form', MatatFiltersForm);
MatatFiltersForm.setListeners();

// Auto-select color variants on page load/refresh
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    autoSelectMatchingColorVariants();
    console.log('Auto-select on page load');
  }, 800);
});

// Also trigger after window load as backup
window.addEventListener('load', function() {
  setTimeout(() => {
    autoSelectMatchingColorVariants();
    console.log('Auto-select on window load');
  }, 1000);
});

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input:not([type="range"])')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class MatatFilterRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    console.log('UPDATE')
    event.preventDefault();
    const form = this.closest('matat-filters-form') || document.querySelector('matat-filters-form');
    form.onActiveFilterClick(event);
    if(event.target.classList.contains('facets__clear')) {
      form.querySelector('.filter-opener').dispatchEvent(new Event('click'));
    }
    MatatFiltersForm.priceRangeSlider();
  }
}

customElements.define('matat-filter-remove', MatatFilterRemove);

window.addEventListener('scroll', () => {
  if(document.querySelectorAll('.facet-filters.sorting')){
       document.querySelectorAll('.facet-filters.sorting .choices').forEach(choice => {
        if (choice.classList.contains('is-open') || choice.classList.contains('is-flipped') || choice.classList.contains('is-focused')) {
          document.querySelector('.collection-nav-bar-main').click()
        }
    });                        
  }
});
document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('MatatFiltersForm')) return;
    var params = new URLSearchParams(window.location.search);
    if (params.has('filter.v.availability')) return;
    params.set('filter.v.availability', '1');
    MatatFiltersForm.renderPage(params.toString());
});